<template>
  <div
    class="ai-card-item"
    :class="{'is-not-active': !item.isActive}"
    data-qa="requirement-item">
    <div>
      <div class="ai-card-item_content">
        <div class="ai-card-item_name">
          {{ $t('AIRequirements.AIRequirement') }}: {{ item.title }}
        </div>
        <div class="ai-card-item_contents">
          <div
            v-for="(contentItem, index) in item.contents"
            :key="`${contentItem}_${index}`">
            <span
              v-if="contentItem.label"
              class="bold">{{ contentItem.label }}:</span> {{ contentItem.value }}
          </div>
        </div>
      </div>
      <div
        class="ai-card-item_status">
        <StatusChip
          v-if="item.mode"
          class="font-size-12 px-2 my-auto"
          :data-qa="`requirement-status-${item.mode}`"
          :name="$t(`AIRequirements.Statuses.${item.mode}`)"
          :status="item.mode"
          text-color="black"/>
        <StatusChip
          v-if="isEdited"
          class="font-size-12 px-2 my-auto"
          :data-qa="`requirement-status-EDITED`"
          :name="$t(`AIRequirements.Statuses.EDITED`)"
          :status="'EDITED'"
          text-color="black"/>


        <StatusChip
          v-if="!item.isActive"
          class="font-size-12 px-2 my-auto"
          :data-qa="`requirement-status-NOT_ACTIVE`"
          :name="$t(`AIRequirements.Statuses.NOT_ACTIVE`)"
          :status="'NOT_ACTIVE'"
          text-color="black"/>
      </div>
    </div>
    <div class="requirement-item_actions">
      <InDevelopmentInfo
        :condition="!isAiFunctionalEnabled"
        :prevent="!isAiFunctionalEnabled">
        <template #activator>
          <TooltipedBtn
            data-qa="btn-add-ai-requirement-edit"
            :disabled="!item.isActive || !isAiFunctionalEnabled || item.loading"
            icon="edit"
            :loading="item.loading"
            :small-btn="true"
            :text="isAiFunctionalEnabled ? $t('AIRequirements.EditAIRequirement') : ''"
            @click="$emit('item-edit')"/>
        </template>
      </InDevelopmentInfo>
      <InDevelopmentInfo
        :condition="!isAiFunctionalEnabled"
        :prevent="!isAiFunctionalEnabled">
        <template #activator>
          <TooltipedBtn
            data-qa="btn-add-ai-requirement-clip"
            :disabled="!isAiFunctionalEnabled || item.loading"
            icon="file-clip"
            :loading="item.loading"
            :small-btn="true"
            :text="isAiFunctionalEnabled ? $t('AIRequirements.ClipAIRequirement') : ''"
            @click="$emit('item-clip')"/>
        </template>
      </InDevelopmentInfo>
      <InDevelopmentInfo
        :condition="!isAiFunctionalEnabled"
        :prevent="!isAiFunctionalEnabled">
        <template #activator>
          <TooltipedBtn
            v-if="item.isActive && item.mode !== 'MANUALLY_ADDED'"
            data-qa="btn-add-ai-requirement-cancel"
            :disabled="!isAiFunctionalEnabled || item.loading"
            icon="cancel"
            :loading="item.loading"
            :small-btn="true"
            :text="isAiFunctionalEnabled ? $t('AIRequirements.CancelAIRequirement') : ''"
            @click="$emit('item-cancel')"/>
        </template>
      </InDevelopmentInfo>
      <InDevelopmentInfo
        :condition="!isAiFunctionalEnabled"
        :prevent="!isAiFunctionalEnabled">
        <template #activator>
          <TooltipedBtn
            v-if="!item.isActive"
            data-qa="btn-add-ai-requirement-restore"
            :disabled="!isAiFunctionalEnabled || item.loading"
            icon="change-file"
            :loading="item.loading"
            :small-btn="true"
            :text="isAiFunctionalEnabled ? $t('AIRequirements.RestoreAIRequirement') : ''"
            @click="$emit('item-restore')"/>
        </template>
      </InDevelopmentInfo>
      <InDevelopmentInfo
        :condition="!isAiFunctionalEnabled"
        :prevent="!isAiFunctionalEnabled">
        <template #activator>
          <TooltipedBtn
            v-if="item.isActive && item.mode === 'MANUALLY_ADDED'"
            data-qa="btn-add-ai-requirement-delete"
            :disabled="!isAiFunctionalEnabled || item.loading"
            icon="delete"
            :loading="item.loading"
            :small-btn="true"
            :text="isAiFunctionalEnabled ? $t('AIRequirements.DeleteAIRequirement') : ''"
            @click="$emit('item-delete')"/>
        </template>
      </InDevelopmentInfo>
    </div>
  </div>
</template>
<script>
import StatusChip from 'components/common/elements/StatusChip.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import InDevelopmentInfo from 'components/common/elements/InDevelopmentInfo.vue'

export default {
  name: 'AiRequirementItem',
  data() {
    return {}
  },
  methods: {},
  computed: {
    isEdited() {
      return this.item.modifiedBy !== null || this.item.modifiedDate !== null
    },
    isAiFunctionalEnabled() {
      return typeof growthBook !== 'undefined' && this.growthBook.ai_functionals
    },
  },
  components: {
    StatusChip,
    TooltipedBtn,
    InDevelopmentInfo
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
}
</script>
<style lang="scss" scoped>
.ai-card-item {
  text-align: left;
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  gap: 24px;
  margin-bottom: 12px;
  padding: 24px;
  background-color: var(--v-main__light_green-base);
  border-color: var(--v-main__light_green-base);
  opacity: 1;
  &.is-not-active {
    opacity: 0.7;
  }

  &_name {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 12px;
    color: var(--black-color);
  }
  &_contents {
    display: grid;
    gap: 10px;
  }
  &_status {
    margin-top: 14px;
    gap: 10px;
    display: flex;
  }
  .requirement-item_actions {
    margin: 0 0 auto 0;
    display: flex;
    gap: 5px;
  }
}
</style>
